import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Adds or updates a ledger name for an entity.
 * POST api/Onboarding/update-individual-ledger
 */
export const updateIndividualLedgerAction = async ({
  id = 0,
  entityPrimaryId = 0,
  entityId = "",
  ledgerName = "",
  entityName = "",
  createdBy = "",
}) => {
  try {
    const response = await apiClient.post(
      ATP_API_URL.UPDATE_INDIVIDUAL_LEDGER,
      {
        id: typeof id === "number" ? id : parseInt(id, 10) || 0,
        entityPrimaryId:
          typeof entityPrimaryId === "number"
            ? entityPrimaryId
            : parseInt(entityPrimaryId, 10) || 0,
        entityId: entityId || "",
        ledgerName: ledgerName || "",
        entityName: entityName || "",
        createdBy: createdBy || "",
      },
    );

    if (response?.status === 200 && response.data) {
      const { success, message } = response.data;
      if (success) {
        return {
          success: true,
          message: message || "Ledger updated successfully",
          data: response.data,
        };
      }
      // API returned success:false (e.g. "Ledger Name Already Exists.")
      return { success: false, message: message || "Failed to update ledger" };
    }
    return { success: false, message: "Failed to update ledger" };
  } catch (error) {
    console.error("[UpdateIndividualLedger] error:", error);
    return {
      success: false,
      message: error.message || "Failed to add ledger",
    };
  }
};
